(() => {
  const state = { drawer: null, backdrop: null, lastTrigger: null, cart: null };

  function rootUrl(path) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}${path}`.replace(/\/\/+/g, '/');
  }

  function formatMoney(cents) {
    const currency = (state.drawer && state.drawer.dataset.currency) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
  }

  function setText(id, value) {
    const node = document.getElementById(id);
    if (node) node.textContent = value || '';
  }

  function openDrawer(trigger) {
    if (!state.drawer || !state.backdrop) return;
    state.lastTrigger = trigger || document.activeElement;
    state.backdrop.hidden = false;
    requestAnimationFrame(() => {
      state.backdrop.classList.add('is-visible');
      state.drawer.classList.add('is-open');
    });
    state.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fog-cart-open');
    const close = state.drawer.querySelector('[data-fog-cart-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function closeDrawer() {
    if (!state.drawer || !state.backdrop) return;
    state.drawer.classList.remove('is-open');
    state.backdrop.classList.remove('is-visible');
    state.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fog-cart-open');
    window.setTimeout(() => { state.backdrop.hidden = true; }, 350);
    if (state.lastTrigger && typeof state.lastTrigger.focus === 'function') state.lastTrigger.focus();
  }

  function updateBadge(itemCount) {
    document.querySelectorAll('.cart-icon .badge, [data-cart-count]').forEach((badge) => { badge.textContent = itemCount; });
    window.cartItemCount = itemCount;
  }

  function updateShipping(cart) {
    const threshold = Number(state.drawer?.dataset.freeShippingThreshold || 13500);
    const progress = document.getElementById('fog-cart-shipping-progress');
    const status = document.getElementById('fog-cart-shipping-status');
    if (!progress || !status) return;
    const subtotal = Number(cart.items_subtotal_price || cart.total_price || 0);
    progress.style.width = `${Math.min(100, (subtotal / threshold) * 100)}%`;
    status.textContent = subtotal >= threshold
      ? 'Complimentary shipping unlocked.'
      : `${formatMoney(threshold - subtotal)} away from complimentary shipping.`;
  }

  function render(item, cart) {
    state.cart = cart;
    const itemBox = document.getElementById('fog-cart-added-item');
    const image = document.getElementById('fog-cart-added-image');
    const message = document.getElementById('fog-cart-message');
    if (message) message.textContent = '';
    if (itemBox) itemBox.hidden = !item;
    if (!item) {
      if (image) { image.removeAttribute('src'); image.alt = ''; }
      setText('fog-cart-added-title', '');
      setText('fog-cart-added-variant', '');
      setText('fog-cart-added-price', '');
    } else if (itemBox) {
      if (image) {
        if (item.image) image.src = item.image; else image.removeAttribute('src');
        image.alt = item.product_title || item.title || '';
      }
      setText('fog-cart-added-title', item.product_title || item.title);
      setText('fog-cart-added-variant', item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
      setText('fog-cart-added-price', formatMoney(item.final_price));
    }
    setText('fog-cart-count', `${cart.item_count} ${cart.item_count === 1 ? 'ITEM' : 'ITEMS'}`);
    setText('fog-cart-total', formatMoney(cart.total_price));
    updateShipping(cart);
    updateBadge(cart.item_count);
  }

  function recommendationCard(product) {
    const variant = product.variants && product.variants.find((v) => v.available) || product.variants?.[0];
    if (!variant) return '';
    const image = product.featured_image || '';
    const image360 = sizedImage(image, 360);
    const image540 = sizedImage(image, 540);
    const image720 = sizedImage(image, 720);
    return `<article class="fog-cart-rec-card">
      <a class="fog-cart-rec-card__image" href="${product.url}"><img src="${image540}" srcset="${image360} 360w, ${image540} 540w, ${image720} 720w" sizes="(min-width: 990px) 280px, 45vw" alt="${product.title.replace(/"/g, '&quot;')}" loading="lazy" decoding="async" fetchpriority="low"></a>
      <div class="fog-cart-rec-card__body">
        <a class="fog-cart-rec-card__title" href="${product.url}">${product.title}</a>
        <p class="fog-cart-rec-card__price">${formatMoney(variant.price)}</p>
        <button type="button" class="fog-cart-rec-card__add" data-fog-rec-add data-variant-id="${variant.id}">ADD</button>
      </div>
    </article>`;
  }

  async function loadRecommendations(productId, cart) {
    const region = document.getElementById('fog-cart-recommendations');
    const list = document.getElementById('fog-cart-recommendations-list');
    if (!region || !list || !productId) return;
    region.hidden = true;
    list.innerHTML = '';
    try {
      const response = await fetch(rootUrl(`recommendations/products.json?product_id=${productId}&limit=4&intent=related`), { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const data = await response.json();
      const cartProductIds = new Set((cart?.items || []).map((item) => Number(item.product_id)));
      const products = (data.products || []).filter((product) => !cartProductIds.has(Number(product.id))).slice(0, 3);
      if (!products.length) return;
      list.innerHTML = products.map(recommendationCard).join('');
      region.hidden = false;
    } catch (error) {
      console.warn('Recommendations unavailable', error);
    }
  }

  async function fetchCart() {
    const separator = rootUrl('cart.js').includes('?') ? '&' : '?';
    const response = await fetch(`${rootUrl('cart.js')}${separator}_fog=${Date.now()}`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    const cart = await response.json();
    if (!response.ok) throw new Error('The cart could not be refreshed.');
    return cart;
  }

  async function addVariant({ variantId, quantity = 1, sellingPlanId = null, trigger = null }) {
    const button = trigger;
    const originalText = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'ADDING...'; button.setAttribute('aria-busy', 'true'); }
    try {
      const cleanVariantId = String(variantId || '').trim();
      if (!/^\d+$/.test(cleanVariantId)) throw new Error('Please select an available product option.');
      const item = { id: cleanVariantId, quantity: Math.max(1, Number(quantity) || 1) };
      if (sellingPlanId) item.selling_plan = String(sellingPlanId);
      const addResponse = await fetch(rootUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
        body: JSON.stringify({ items: [item] })
      });
      const addData = await addResponse.json();
      if (!addResponse.ok) throw new Error(addData.description || 'This item could not be added.');
      let cart = null;
      let addedItem = null;
      const confirmationDelays = [0, 150, 300, 600, 1000];
      for (const delay of confirmationDelays) {
        if (delay) await new Promise((resolve) => window.setTimeout(resolve, delay));
        try {
          cart = await fetchCart();
          addedItem = (cart.items || []).find((line) => String(line.variant_id) === cleanVariantId);
          if (addedItem && Number(cart.item_count) >= 1) break;
        } catch (refreshError) {
          // The add request already succeeded. Continue bounded retries before falling back to /cart.
        }
      }
      if (!addedItem || !cart || Number(cart.item_count) < 1) {
        window.location.assign(rootUrl('cart'));
        return { cart: null, item: (addData.items && addData.items[0]) || null, redirected: true };
      }
      render(addedItem, cart);
      openDrawer(button);
      loadRecommendations(addedItem?.product_id, cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, item: addedItem } }));
      return { cart, item: addedItem };
    } catch (error) {
      const message = document.getElementById('fog-cart-message');
      if (message) message.textContent = error.message || 'Unable to add this item.';
      openDrawer(button);
      throw error;
    } finally {
      if (button) { button.disabled = false; button.textContent = originalText; button.removeAttribute('aria-busy'); }
    }
  }

  function addFromProduct(productId, trigger) {
    const variant = document.getElementById(`variant-select-${productId}`);
    const quantity = document.getElementById(`quantity-${productId}`);
    if (!variant) return Promise.reject(new Error('Variant selector not found.'));
    return addVariant({ variantId: variant.value, quantity: quantity ? quantity.value : 1, trigger });
  }

  function init() {
    state.drawer = document.getElementById('fog-cart-drawer');
    state.backdrop = document.getElementById('fog-cart-backdrop');
    if (!state.drawer || !state.backdrop) return;
    state.drawer.dataset.currency = state.drawer.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    document.querySelectorAll('[data-fog-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
    state.backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-fog-rec-add]');
      if (!button) return;
      addVariant({ variantId: button.dataset.variantId, quantity: 1, trigger: button });
    });
    fetchCart().then((cart) => { render(null, cart); }).catch(() => {});
  }

  window.FOGCart = { addVariant, addFromProduct, open: openDrawer, close: closeDrawer };
  document.addEventListener('DOMContentLoaded', init);
})();
